import React from 'react';
import PropTypes from 'prop-types';
import {Bar, BarChart, CartesianGrid, ResponsiveContainer, XAxis, YAxis} from 'recharts';

const getPath = (x, y, width, height) => {
    return `M${x},${y + height}
          C${x + width / 3},${y + height} ${x + width / 2},${y + height / 3} ${x + width / 2}, ${y}
          C${x + width / 2},${y + height / 3} ${x + 2 * width / 3},${y + height} ${x + width}, ${y + height}
          Z`;
};

const TriangleBar = (props) => {
    const {fill, x, y, width, height} = props;

    return <path d={getPath(x, y, width, height)} stroke="none" fill={fill}/>;
};

TriangleBar.propTypes = {
    fill: PropTypes.string,
    x: PropTypes.number,
    y: PropTypes.number,
    width: PropTypes.number,
    height: PropTypes.number,
};
const BestSellingMonthBarChart = (data) => {
    let chartData = [];
    if (data.data) {
        for (let i = 0; i < data.data.length; i++) {
            chartData.push({name: data.data[i].InApp_Title, Count: data.data[i].Count})
        }
    }


    return (
        <ResponsiveContainer width="100%" height={200} className="unset-position">
            <BarChart data={chartData}
                      margin={{top: 10, right: -25, left: 0, bottom: 0}}>
                <XAxis dataKey="name"/>
                <YAxis style={{textAnchor: 'start'}}/>
                <CartesianGrid strokeDasharray="3 3"/>
                <Bar dataKey="Count" fill="#3367d6" shape={<TriangleBar/>} label/>
            </BarChart>
        </ResponsiveContainer>
    );
}

export default BestSellingMonthBarChart;



// WEBPACK FOOTER //
// ./app/routes/apall/Dashboard/Components/BestSellingMonthBarChart.js